import {
  SIM_PREPARING,
  SIM_UPDATE_DOWNLOAD_PROGRESS,
  SIM_UPDATE_STATUS,
  SIM_ISVT_ENABLED,
  SIM_IS_RUNNING,
  SIM_IS_INSTALLED,
  SIM_POPUP_INFO,
  SIM_PREPARE_DONE,
  SIM_PREPARE_FAILED,
} from '../constants/asimstatus';

const initState = {
  status: SIM_PREPARING,
  SIMDowning: false,
  progress: 0,
  isvteabled: null,
  issimrunning: null,
  issiminstalled: null,
  SIMPopupInfo: null,
};

const asimstatus = (state = initState, action = {}) => {
  let SIMDowning = false;

  switch (action.type) {
    case SIM_UPDATE_DOWNLOAD_PROGRESS:
      return { ...state, progress: action.progress };
    case SIM_UPDATE_STATUS:
      if (action.status === SIM_PREPARE_DONE || action.status === SIM_PREPARE_FAILED) {
        SIMDowning = false;
      } else {
        SIMDowning = true;
      }
      return { ...state, status: action.status, SIMDowning };
    case SIM_ISVT_ENABLED:
      return { ...state, isvteabled: action.isVTEabled };
    case SIM_IS_RUNNING:
      return { ...state, issimrunning: action.isSIMRunning };
    case SIM_IS_INSTALLED:
      return { ...state, issiminstalled: action.isSIMInstalled };
    case SIM_POPUP_INFO:
      return { ...state, SIMPopupInfo: action.payload };
    default:
      return state;
  }
};

export default asimstatus;
